import { BoardBase, BoardView } from './BoardBase';
import { OliGroup } from './groupByOli';

interface Props {
	view?: BoardView;
	selectedGroup?: OliGroup | null;
	onSelect?: (g: OliGroup | null) => void;
}

/** Unassigned board — readiness lanes over the unassigned cards. Selection is
 *  lifted to the tablet page's shared left sidebar (BoardBase toggles re-tap). */
export const UnassignedBoard = ({ view, selectedGroup, onSelect }: Props = {}) => (
	<BoardBase
		title="Unassigned"
		filter={{ current_area: 'unassigned' }}
		view={view}
		selectedGroup={selectedGroup}
		onSelect={onSelect}
	/>
);
